import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Format value as percentage
        }

        // Extend the summTreeColumn filter to customize its behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary for the tree column.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result variable
                    var resultFormat = 0; // Initialize formatted result variable
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result); // Format as integer
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%'; // Format as percentage
                        } else {
                            resultFormat = webix.i18n.priceFormat(result); // Format as price
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn
        );

        // Return the layout configuration for the view
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'treetable', // Unique ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            bready: function () {
                                this.openAll(); // Open all rows by default
                            },
                            scrollY: screen.width < 820 ? false : true, // Enable/disable vertical scrolling based on screen width
                            height: screen.width < 820 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Fecha', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Return group header
                                            );
                                        return obj.Fecha; // Return date value
                                    },
                                },
                                {
                                    id: 'CantidadTickets', // Column ID
                                    header: _('Cantidad Tickets'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 80, // Column width
                                },
                                {
                                    id: 'Stake', // Column ID
                                    header: _('Apuesta'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 100, // Column width
                                },
                                {
                                    id: 'StakePromedio', // Column ID
                                    header: _('Apuesta Promedio'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 80, // Column width
                                },
                                {
                                    id: 'Payout', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 100, // Column width
                                },
                                {
                                    id: 'Bonos', // Column ID
                                    header: _('Bonos'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 80, // Column width
                                },
                                {
                                    id: 'Ggr', // Column ID
                                    header: _('GGR'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 100, // Column width
                                },
                                {
                                    id: 'GgrPorc', // Column ID
                                    header: _('GGR %'), // Column header with localization
                                    format: percentFormat, // Format as percentage
                                    width: 100, // Column width
                                },
                                {
                                    id: 'UsersRegistered', // Column ID
                                    header: _('Usuarios Registrados'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 90, // Column width
                                },
                                {
                                    id: 'FirstDeposits', // Column ID
                                    header: _('Primeros Depósitos'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 100, // Column width
                                },
                                {
                                    id: 'Moneda', // Column ID
                                    header: _('Moneda'), // Column header with localization
                                    width: 75, // Column width
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                /**
                                 * Event triggered after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            /**
                             * Event triggered when the grid is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('treetable'); // Get the tree table instance
        var url = devConfig.geturlApi() + 'es/Financial/GetInformeGerencial?Partner=' + id_partner + '&'; // Construct the API URL

        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        // Attach event handler for after loading data
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                /**
                 * Grouping function for data.
                 * @param {Object} obj - The data object.
                 * @returns {string} The HTML string for grouping.
                 */
                by: function (obj) {
                    return (
                        "<i class='flags " +
                        obj.CountryIcon +
                        "'></i>" +
                        obj.Pais +
                        ' ' +
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner; // Filter partner by ID
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    ); // Return HTML for grouping
                },
                map: {
                    CantidadTickets: ['CantidadTickets', 'sum'], // Sum of tickets
                    Stake: ['Stake', 'sum'], // Sum of stakes
                    StakePromedio: [
                        'StakePromedio',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Initialize sum variable
                            var summ2 = 0; // Initialize count variable
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Log each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Sum stakes
                                summ2 = summ2 + Math.floor(data[i].CantidadTickets); // Sum ticket counts
                            }
                            console.log(summ1); // Log total stakes
                            console.log(summ2); // Log total tickets
                            return summ1 / summ2; // Return average stake
                        },
                    ],
                    Payout: ['Payout', 'sum'], // Sum of payouts
                    Bonos: ['Bonos', 'sum'], // Sum of bonuses
                    Ggr: ['Ggr', 'sum'], // Sum of GGR
                    GgrPorc: [
                        'GgrPorc',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Initialize sum variable
                            var summ2 = 0; // Initialize count variable
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Log each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Sum stakes
                                summ2 = summ2 + Math.floor(data[i].Ggr); // Sum GGR
                            }
                            console.log(summ1); // Log total stakes
                            console.log(summ2); // Log total GGR
                            return (summ2 / summ1) * 100; // Return GGR percentage
                        },
                    ],
                    UsersRegistered: ['UsersRegistered', 'sum'], // Sum of registered users
                    FirstDeposits: ['FirstDeposits', 'sum'], // Sum of first deposits
                    Partner: ['Partner'], // Partner ID
                },
            });
            // Group data by partner
            $$('treetable').data.group({
                by: function (obj) {
                    return (
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner; // Filter partner by ID
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    ); // Return HTML for grouping
                },
                map: {
                    Partner: ['Partner'], // Partner ID
                    CantidadTickets: ['CantidadTickets', 'sum'], // Sum of tickets
                    Stake: ['Stake', 'sum'], // Sum of stakes
                    StakePromedio: [
                        'StakePromedio',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Initialize sum variable
                            var summ2 = 0; // Initialize count variable
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Log each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Sum stakes
                                summ2 = summ2 + Math.floor(data[i].CantidadTickets); // Sum ticket counts
                            }
                            console.log(summ1); // Log total stakes
                            console.log(summ2); // Log total tickets
                            return summ1 / summ2; // Return average stake
                        },
                    ],
                    Payout: ['Payout', 'sum'], // Sum of payouts
                    Bonos: ['Bonos', 'sum'], // Sum of bonuses
                    Ggr: ['Ggr', 'sum'], // Sum of GGR
                    GgrPorc: [
                        'GgrPorc',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Initialize sum variable
                            var summ2 = 0; // Initialize count variable
                            for (var i = data.length - 1; i >= 0; i--) {
                                console.log(data[i]); // Log each data item
                                summ1 = summ1 + Math.floor(data[i].Stake); // Sum stakes
                                summ2 = summ2 + Math.floor(data[i].Ggr); // Sum GGR
                            }
                            console.log(summ1); // Log total stakes
                            console.log(summ2); // Log total GGR
                            return (summ2 / summ1) * 100; // Return GGR percentage
                        },
                    ],
                    UsersRegistered: ['UsersRegistered', 'sum'], // Sum of registered users
                    FirstDeposits: ['FirstDeposits', 'sum'], // Sum of first deposits
                },
            });
        });

        // Event handler for filtering data
        this.on(this.app, 'informeGerencial:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add start date to query
                                string1 = string1 + '&dateTo=' + date; // Add end date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
